import { useState, useEffect } from 'react'
import { Box, Heading, Flex, Divider } from '@chakra-ui/react'
import { isBlank } from '@!/Util'
import { useRanking, useFreeTitles } from '@!/Hooks'
import { TagItem } from '@!/Store/Home/components'
import { useTabs } from '@!/Store/Ranking/hooks/useTabs'
import RankingTitleList from '@!/Store/Ranking/components/RankingTitleList'
import { TagSearchBox } from '@!/Store/Common/containers'
import { ScrollableTitles } from '@!/Store/Common/components'

const Ranking = ({ rankingType, searchTags }) => {
  const { currentTab, tabs, handleTabChange } = useTabs(rankingType)
  const isActive = (index) => index === currentTab.index
  const currentPage = 1
  const fetchType = rankingType ? 'top' : null
  const { data: rankingTitles } = useRanking(currentTab.name, currentPage, fetchType)
  const [genreTabName, setGenreName] = useState(null)
  const [genreTabLabel, setGenreLabel] = useState('同ジャンル')
  const { data: freeTitlesData } = useFreeTitles(genreTabName, 1, 'top')
  const freeTitles = freeTitlesData?.titles ?? []

  useEffect(() => {
    if (['boy', 'man'].includes(rankingType)) {
      setGenreName('man')
      setGenreLabel('少年・青年ジャンル')
    } else if (['girl', 'lady'].includes(rankingType)) {
      setGenreName('woman')
      setGenreLabel('少女・女性ジャンル')
    }
  }, [rankingType])

  return (
    <>
      <Box px={4} py={6}>
        <Heading as="h1" fontSize="md" mb={4}>
          デイリー人気ランキング
        </Heading>
        <Flex flexWrap="wrap" gap={1}>
          {tabs.map((tab, index) => (
            <Box key={tab.name}>
              <TagItem
                name={tab.label}
                as="a"
                whiteSpace="nowrap"
                bg={isActive(index) && 'label.primary'}
                color={isActive(index) && 'label.white'}
                fontSize="xs"
                px={3}
                cursor="pointer"
                onClick={() => {
                  handleTabChange(index)
                }}
              />
            </Box>
          ))}
        </Flex>
        <Divider my={4} />
        {!isBlank(rankingTitles) && <RankingTitleList rankingTitles={rankingTitles} currentTab={currentTab} />}
      </Box>
      <Divider m={4} w="auto" />
      <ScrollableTitles
        titles={freeTitles}
        sectionTitle={`${genreTabLabel}の無料作品一覧`}
        url={genreTabName ? `/store/search/free/${genreTabName}` : '/store/search/free'}
      />
      <Divider m={4} w="auto" />
      <TagSearchBox searchTags={searchTags} genreTabName={genreTabName} />
    </>
  )
}

export default Ranking
